import { createRoutine } from 'redux-saga-routines'
import { IPatientState } from './patient.interface'

const initialPatientState: IPatientState = {
  patients: [],
  readings: [],
  error: false,
  loading: false,
  assignDeviceLoading: false,
  patientProfileloading: false,
  settingsLoading: false,
  success: false,
}

export const addPatient = createRoutine('ADD_PATIENT')
export const showPatient = createRoutine('SHOW_PATIENT')
export const editPatient = createRoutine('EDIT_PATIENT')
export const getAllPatients = createRoutine('GET_ALL_PATIENTS')
export const getAllPatientsReadings = createRoutine('GET_ALL_PATIENTS_READINGS')
export const updateSelectedPatient = createRoutine('UPDATE_SELECTED_PATIENT')
export const assignDevice = createRoutine('ASSIGN_DEVICE')
export const unAssignDevice = createRoutine('UNASSIGN_DEVICE')
export const clearSelectedPatient = createRoutine('CLEAR_SELECTED_PATIENT')
export const clearPatients = createRoutine('CLEAR_PATIENTS')
export const getSettings = createRoutine('GET_SETTINGS')
export const editSettings = createRoutine('EDIT_SETTINGS')

export default function patient(state = initialPatientState, action: any) {
  switch (action.type) {
    case addPatient.TRIGGER:
      return { ...state, loading: true, error: false, success: false }
    case addPatient.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        patients: action.payload,
        error: false
      }
    case addPatient.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        patients: action.payload,
        error: true
      }
    case assignDevice.TRIGGER:
      return { ...state, assignDeviceLoading: true, error: false, success: false }
    case assignDevice.SUCCESS:
      return {
        ...state,
        assignDeviceLoading: false,
        success: true,
        selectedPatient: {
          ...state.selectedPatient,
          device: action.payload

        },
        error: false
      }
    case assignDevice.FAILURE:
      return {
        ...state,
        assignDeviceLoading: false,
        success: false,
        error: true
      }
    case unAssignDevice.TRIGGER:
      return { ...state, loading: true, error: false, success: false }
    case unAssignDevice.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        selectedPatient: {
          ...state.selectedPatient,
          device: null
        },
        error: false
      }
    case unAssignDevice.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }

    case showPatient.TRIGGER:
      return {
        ...state,
        patientProfileloading: true,
        loading: true,
        error: false,
        success: false,
        selectedPatient: undefined
      }
    case showPatient.SUCCESS:
      return {
        ...state,
        loading: false,
        patientProfileloading: false,
        success: true,
        selectedPatient: {
          ...action.payload.patient,
          settings: {
            ...action.payload.settings
          }
        },
        error: false
      }
    case showPatient.FAILURE:
      return {
        ...state,
        loading: false,
        patientProfileloading: false,
        success: false,
        error: true
      }
    case clearSelectedPatient.TRIGGER:
      return {
        ...state,
      }
    case clearSelectedPatient.SUCCESS:
      return {
        ...state,
        selectedPatient: undefined
      }
    case clearPatients.TRIGGER: {
      return {
        ...state,
        patients: []
      }
    }
    case editPatient.TRIGGER:
      return { ...state, loading: true, error: false, success: false }
    case editPatient.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        selectedPatient: Object.assign({}, state.selectedPatient, action.payload),
        error: false
      }
    case editPatient.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }

    case getAllPatients.TRIGGER:
      return { ...state, loading: true, patients: [], meta: undefined, error: false, success: false }
    case getAllPatients.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        patients: action.payload.patients,
        meta: action.payload.meta,
        error: false
      }
    case getAllPatients.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }

    case getAllPatientsReadings.TRIGGER:
      return { ...state, loading: true, readings: [], error: false, success: false }
    case getAllPatientsReadings.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        readings: action.payload.readings,
        meta: action.payload.meta,
        error: false
      }
    case getAllPatientsReadings.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }

    case getSettings.TRIGGER: {
      return { ...state, loading: true, error: false, success: false }
    }
    case getSettings.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        selectedPatient:
        {
          ...state.selectedPatient,
          settings: action.payload
        },
        error: false
      }
    }
    case getSettings.FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
    }
    case editSettings.TRIGGER: {
      return { ...state, settingsLoading: true, error: false, success: false }
    }
    case editSettings.SUCCESS: {
      const object = {
        ...state,
        settingsLoading: false,
        success: true,
        selectedPatient: {
          ...state.selectedPatient,
          settings: action.payload,
        },
        error: false
      }
      if (action.payload.careManagerId) {
        return Object.assign(object,
          { selectedPatient: { ...state.selectedPatient, careManagerId: action.payload.careManagerId } })
      }
      return object
    }
    case editSettings.FAILURE: {
      return {
        ...state,
        settingsLoading: false,
        success: false,
        error: true
      }
    }
    case updateSelectedPatient.TRIGGER: {
      return {
        ...state,
        selectedPatient: {
          ...state.selectedPatient!,
          careManagerId: action.payload
        },
        success: false
      }
    }

    default:
      return state
  }
}

